// Change nav on scroll
const header = document.querySelector("nav.navbar-wrapper");

const addClassOnScroll = () => header.classList.add("sticky");
const removeClassOnScroll = () => header.classList.remove("sticky");
let navbarOpened = false;

window.addEventListener("scroll", function () {
  let scrollpos = window.scrollY;

  if (scrollpos > 60) {
    addClassOnScroll();
  }
  // We separate the two if statements to avoid flickering
  if (scrollpos < 30) {
    removeClassOnScroll();
  }
});
